import { Navigate } from 'react-router';

import { useWaitUserPermissions } from '~platform/auth';

import { ROUTES } from '~shared/config/routes';
import { Loader } from '~shared/ui/loader';

export const SignedScreen = () => {
  const userInfoQuery = useWaitUserPermissions();

  if (userInfoQuery.isFetching) {
    return <Loader />;
  }

  return <Navigate to={ROUTES.partner.applicationMenu} />;
};
